import React, { useState } from 'react';
import styles from './UserRating.module.scss';
import FormWrapper from '../../../BaseModule/Components/Form/FormWrapper';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
	RatingType,
	useCreateRatingMutation,
} from '../../../../graphql/graphql';
import { useAppContext } from '../../../../Services/AppContext';
import SubmitButton from '../../../BaseModule/Components/Button/SubmitButton';
import TextAreaField from '../../../BaseModule/Components/Form/Components/TextAreaField/TextAreaField';
import Text from '../../../BaseModule/Components/Text';
import StarInputField from '../../../BaseModule/Components/Form/Components/StarInputField/StarInputField';
import useApiClient from '../../../../Hooks/useApiClient';
import useNotification from '../../../../Hooks/useNotification';
import useTranslation from '../../../../Hooks/useTranslation';
import FullPageLoading from '../../../BaseModule/Components/FullPageLoading';

interface Props {
	caseId?: string;
}

const UserRating: React.FC<Props> = ({ caseId }) => {
	const [isLoading, setIsLoading] = useState(false);
	const { userData } = useAppContext();
	const { displayGQLMutationError } = useApiClient();
	const { showNotificationSuccess } = useNotification();
	const { t } = useTranslation();
	const [createRating] = useCreateRatingMutation();

	const validationSchema = yup.object({
		//promoCode: yup.string().required(),
	});

	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
	});

	const handleSuccess = async (values: any) => {
		setIsLoading(true);
		const response: any = await createRating({
			input: {
				userId: userData.id,
				text: values.text,
				caseId,
				stars: values.stars,
				type: RatingType.Stars,
			},
		});
		if ((response?.error?.errors?.length || 0) > 0) {
			displayGQLMutationError(response?.error?.errors);
		}
		if (response.data?.createRating.id) {
			showNotificationSuccess({
				content: t('component.userRating.ratingSaved'),
			});
			setTimeout(() => {
				// @ts-ignore
				window.location.href = '/';
			}, 1000);
		}
		setIsLoading(false);
	};

	return (
		<div className={styles.wrapper}>
			{isLoading && <FullPageLoading />}
			<Text tx='component.userRating.title' className={styles.title} />
			<div>
				<FormWrapper formMethods={formMethods}>
					<StarInputField name='stars' ratingRange={5} />
					<TextAreaField
						name='text'
						label='component.userRating.yourComment'
						className='mt-4'
					/>
					<SubmitButton
						onSubmit={handleSuccess}
						className='btn btn-submit mt-2'
						title='base.shared.form.send'
					/>
				</FormWrapper>
			</div>
		</div>
	);
};

export default UserRating;
